export const courierData = [
    {
      id: "c1",
      name: "BlueDart Express",
      code: "BDE",
      contactPerson: "Rahul Sharma",
      phone: "+91 98765 43210",
      status: "Active",
      services: [
        {
          id: "s1",
          name: "Domestic Priority",
          code: "DP",
          deliveryDays: "1-2 days",
          mode: "Air",
          rateCards: [
            {
              id: "rc1",
              name: "Metro Zone Card",
              zone: "Metro",
              effectiveFrom: "2024-01-01",
              slabs: [
                { id: "sl1", fromWeight: 0, toWeight: 0.5, ratePerKg: 80, minCharge: 40 },
                { id: "sl2", fromWeight: 0.5, toWeight: 2, ratePerKg: 60, minCharge: 40 },
                { id: "sl3", fromWeight: 2, toWeight: 5, ratePerKg: 50, minCharge: 100 },
                { id: "sl4", fromWeight: 5, toWeight: 10, ratePerKg: 45, minCharge: 225 },
              ],
            },
            {
              id: "rc2",
              name: "Regional Zone Card",
              zone: "Regional",
              effectiveFrom: "2024-01-01",
              slabs: [
                { id: "sl5", fromWeight: 0, toWeight: 0.5, ratePerKg: 100, minCharge: 50 },
                { id: "sl6", fromWeight: 0.5, toWeight: 2, ratePerKg: 80, minCharge: 50 },
                { id: "sl7", fromWeight: 2, toWeight: 5, ratePerKg: 65, minCharge: 130 },
              ],
            },
          ],
        },
        {
          id: "s2",
          name: "Surface Economy",
          code: "SE",
          deliveryDays: "5-7 days",
          mode: "Surface",
          rateCards: [
            {
              id: "rc3",
              name: "All India Surface",
              zone: "All India",
              effectiveFrom: "2024-02-01",
              slabs: [
                { id: "sl8", fromWeight: 0, toWeight: 1, ratePerKg: 35, minCharge: 35 },
                { id: "sl9", fromWeight: 1, toWeight: 5, ratePerKg: 28, minCharge: 35 },
                { id: "sl10", fromWeight: 5, toWeight: 20, ratePerKg: 22, minCharge: 110 },
              ],
            },
          ],
        },
      ],
    },
    {
      id: "c2",
      name: "Delhivery",
      code: "DLV",
      contactPerson: "Priya Singh",
      phone: "+91 87654 32109",
      status: "Active",
      services: [
        {
          id: "s3",
          name: "Express Delivery",
          code: "EXP",
          deliveryDays: "2-3 days",
          mode: "Express",
          rateCards: [
            {
              id: "rc4",
              name: "Standard Express Card",
              zone: "Pan India",
              effectiveFrom: "2024-03-01",
              slabs: [
                { id: "sl11", fromWeight: 0, toWeight: 0.5, ratePerKg: 70, minCharge: 35 },
                { id: "sl12", fromWeight: 0.5, toWeight: 3, ratePerKg: 55, minCharge: 35 },
                { id: "sl13", fromWeight: 3, toWeight: 10, ratePerKg: 42, minCharge: 126 },
                { id: "sl14", fromWeight: 10, toWeight: 25, ratePerKg: 38, minCharge: 380 },
              ],
            },
          ],
        },
      ],
    },
  ];
  
  export function calculateRate(courierId, serviceId, rateCardId, weight, couriers) {
    const data = couriers || courierData;
  
    const courier = data.find((c) => c.id === courierId);
    if (!courier) return { rate: 0, slab: null };
  
    const service = courier.services.find((s) => s.id === serviceId);
    if (!service) return { rate: 0, slab: null };
  
    const rateCard = service.rateCards.find((rc) => rc.id === rateCardId);
    if (!rateCard) return { rate: 0, slab: null };
  
    const slab = rateCard.slabs.find(
      (s) => weight >= s.fromWeight && weight < s.toWeight
    );
  
    if (!slab) {
      const lastSlab = rateCard.slabs[rateCard.slabs.length - 1];
  
      if (weight >= lastSlab.fromWeight) {
        const computed = weight * lastSlab.ratePerKg;
        return {
          rate: Math.max(computed, lastSlab.minCharge),
          slab: lastSlab,
        };
      }
  
      return { rate: 0, slab: null };
    }
  
    const computed = weight * slab.ratePerKg;
    return {
      rate: Math.max(computed, slab.minCharge),
      slab,
    };
  }